<script>
    import { highlightKeyword } from './utils.js';
    export let keyword = '';
    export let label;
    export let description = null;
    export let imageUrl = null;
    export let showDescription = false;
    export let showImage = false;
    export let showTooltip = false;
    export let height = 50;
    export let padding = 0;
    export let colLabelWidth = 100;
    export let colDescriptionWidth = 400;
    export let colImageWidth = 50;
    let width = parseInt(colLabelWidth)
                + parseInt(showImage ? colImageWidth : 0);
    export let imgHeight = height - 20;
    export let imgWidth = imgHeight;
    export let selectedBackgroundColor = '#007aff';
    export let selectedFontColor = '#fff';
    export let hoverBackgroundColor = '#e7f2ff';
    export let hoverFontColor = '#ccc';
    export let isActive = false;
    export let isHover = false;
    export let autoWidth = false;
    export let centerItem = false;
    let rowClasses = '';
    $: rowClasses = `row ${isActive ? 'active' : ''} ${isHover ? 'hover' : ''}`;
    let rowStyle = `
        ${autoWidth ? "width: auto;" : ""}
        ${centerItem ? 'justify-content: center;' : ''}
        --height:${height}px;
        --width:${width}px;
        --padding:${padding}px;
        --selected-background-color:${selectedBackgroundColor};
        --selected-font-color:${selectedFontColor};
        --hover-background-color:${hoverBackgroundColor};
        --hover-font-color:${hoverFontColor};
        --col-label-width:${colLabelWidth}px;
        --col-description-width:${colDescriptionWidth}px;
        --col-image-width:${colImageWidth}px;
        --img-height:${imgHeight}px;
        --img-width:${imgWidth}px;
    `;
    const labelStyles = autoWidth ? 'width: auto;' : '';
</script>

<div class={rowClasses} style={rowStyle}>
    {#if showImage}
        <div class='col-image'>
            <img src='{imageUrl}' alt='{label}' />
        </div>
    {/if}
    {#if showDescription}
        <div class='col-label' title={showTooltip ? description : null}>
            <div class='text'>{@html highlightKeyword(label, keyword)}</div>
            <div class='subtext'>{@html highlightKeyword(description, keyword)}</div>
        </div>
    {:else}
        <div class='col-label' title={showTooltip ? label : null} style={labelStyles}>
            <div class='label' style={labelStyles}>{@html highlightKeyword(label, keyword)}</div>
        </div>
    {/if}

</div>

<style>
    .row {
        cursor: pointer;
        width: var(--width);
        height: var(--height);
        line-height: var(--height);
        padding: 0 var(--padding);
        margin: auto 0;
        overflow: hidden;
        white-space: nowrap;
        align-items: left;
        display: flex;
        vertical-align: middle;
    }

    .row.active {
        background: var(--selected-background-color);
    }

    .row:hover:not(.active) {
        background: var(--hover-background-color);
    }

    .row.hover:not(.active) {
        background: var(--hover-background-color);
    }

    .col-image {
        width: var(--col-image-width);
        height: var(--height);
        display: inline-block;
        overflow: hidden;
    }

    .col-image img {
        width: var(--img-width);
        height: var(--img-height);
        padding: 10px;
    }

    .col-label {
        width: var(--col-label-width);
        height: var(--height);
        display: inline-block;
        color: #606060;
    }

    .col-label .label {
        color: #606060;
        line-height: var(--height);
        height: 100%;
        display: block;
        white-space: nowrap;
        text-align: left;
        font-size: medium;
        padding: 0;
        margin: 0;
        font-weight: bold;
        width: var(--col-label-width);
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .col-label .text {
        height: 50%;
        line-height: 65px;
        display: block;
        white-space: nowrap;
        text-align: left;
        font-size: medium;
        padding: 0;
        margin: 0;
        font-weight: bold;
        width: var(--col-label-width);
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .col-label .subtext {
        height: 50%;
        line-height: 30px;
        display: block;
        white-space: nowrap;
        text-align: left;
        font-size: small;
        padding: 0;
        margin: 0;
        width: var(--col-label-width);
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .row.active .col-label, .row.active .col-label .label, .row.active .col-description {
        color: var(--selected-font-color);
    }

    .row:hover:not(.active) .col-label, .row:hover:not(.active) .col-description {
        color: var(--hover-font-color);
    }

    .row.hover:not(.active) .col-label, .row.hover:not(.active) .col-description {
        color: var(--hover-font-color);
    }
</style>
